
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/training",
      function () {
        return require("private-next-pages/training.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/training"])
      });
    }
  